import { PageViewEventLogger } from '@repo/tracking-service';
import { ReactElement } from 'react';

import { LocationFormContainer } from '@/components/survey/business/first-location/LocationFormContainer';
import { BusinessProvider } from '@/components/survey/common/BusinessProvider';
import { LocationProvider } from '@/components/survey/common/LocationProvider';
import { SurveyProvider } from '@/components/survey/common/SurveyProvider';
import { useSurveyUserEventAttributes } from '@/components/survey/common/hooks/use-survey-user-event-attributes';

function LocationFormPage() {
  const eventAttributes = useSurveyUserEventAttributes();

  return (
    <PageViewEventLogger pageName={'survey_relocation-address-input'} eventProperty={eventAttributes}>
      <LocationFormContainer />
    </PageViewEventLogger>
  );
}

LocationFormPage.getLayout = (page: ReactElement) => (
  <SurveyProvider>
    <BusinessProvider>
      <LocationProvider>{page}</LocationProvider>
    </BusinessProvider>
  </SurveyProvider>
);

export default LocationFormPage;
